module.exports = __webpack_public_path__ + "assets/img/selec-project-icon.de3e2052.png";